import { FC, memo, PropsWithChildren } from 'react';

import { useWorkflowSessionManagement } from './hooks/useWorkflowSessionManagement/useWorkflowSessionManagement';
import { WorkflowSessionContext } from './WorkflowSessionContext';
import { WorkflowSessionSubscriptions } from './WorkflowSessionSubscriptions';

const WorkflowSessionProviderComponent: FC<PropsWithChildren> = ({
  children,
}) => {
  const value = useWorkflowSessionManagement();

  return (
    <WorkflowSessionContext.Provider value={value}>
      {value.hasInitialised && <WorkflowSessionSubscriptions />}
      {children}
    </WorkflowSessionContext.Provider>
  );
};

export const WorkflowSessionProvider = memo(WorkflowSessionProviderComponent);
